export default __webpack_public_path__ + "static/media/electric-meter-voltage.66a47b4e.png";